"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareGroupAnimations = exports.groupElements = exports.ungroupElements = exports.createTargetGroup = exports.createGroupContainer = exports.getBBox = void 0;
function getBBox(element) {
    if ('getBBox' in element) {
        return element.getBBox();
    }
    return undefined;
}
exports.getBBox = getBBox;
function createGroupContainer(targets) {
    if (!(targets === null || targets === void 0 ? void 0 : targets.length))
        return;
    const groupContainer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    groupContainer.setAttribute('class', 'group element');
    let isContainerInserted = false;
    for (let i = 0; i < targets.length; i++) {
        const target = targets[i];
        if (!(target === null || target === void 0 ? void 0 : target.parentElement))
            continue;
        if (!isContainerInserted) {
            target.insertAdjacentElement('afterend', groupContainer);
            groupContainer.setAttribute('data-id', target.id);
            isContainerInserted = true;
        }
        groupContainer.appendChild(target);
    }
    return groupContainer;
}
exports.createGroupContainer = createGroupContainer;
function createTargetGroup() {
    const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    group.classList.add('animated-group', 'element');
    return group;
}
exports.createTargetGroup = createTargetGroup;
function ungroupElements(svg) {
    if (!svg)
        return svg;
    let target = svg.querySelector('g.element.group');
    while (target) {
        const parent = target.parentNode;
        const anchor = target.nextSibling;
        const children = new Array(target.childNodes.length);
        let i = 0;
        while (target.firstChild && parent) {
            let child = target.firstChild;
            children[i++] = child = parent.insertBefore(child, anchor);
        }
        parent && parent.removeChild(target);
        children.forEach((child) => child.classList.add('element'));
        target = svg.querySelector('g.element.group');
    }
    return svg;
}
exports.ungroupElements = ungroupElements;
function groupElements(animate, svg) {
    var _a;
    if (!((_a = animate === null || animate === void 0 ? void 0 : animate.groupAnimations) === null || _a === void 0 ? void 0 : _a.length))
        return svg;
    animate.groupAnimations.forEach((group) => {
        const elements = group.elements;
        const targets = [
            ...svg.querySelectorAll(elements.map((stringId) => '#' + stringId).join(', ')),
        ];
        createGroupContainer(targets);
    });
    return svg;
}
exports.groupElements = groupElements;
function prepareGroupAnimations(svgElement, animate) {
    var _a;
    const groupAnimations = (_a = animate.groupAnimations) !== null && _a !== void 0 ? _a : [];
    const svgGroups = [...svgElement.querySelectorAll('.main > .element.group')];
    groupAnimations.forEach((group) => {
        /*
         * Create a new group element for each group
         * The group element is inserted after the first element in the group to maintain layer order
         * The elements are selected using querySelectorAll on the same selector to maintain layer order within the group
         * The logic needs to match API logic
         */
        const selector = group.elements.map((element) => `#${element}`).join(', ');
        const target = [...svgElement.querySelectorAll(selector)];
        const groupElement = createTargetGroup();
        /*
         * The group element is inserted after the first element in the group
         * The layer order of the group is determined by the first element in the group
         */
        const candidate = target[0] &&
            svgGroups.find((group) => group.querySelector(`#${target[0].id}`));
        groupElement.setAttribute('data-id', target[0].id);
        (candidate !== null && candidate !== void 0 ? candidate : target[0]).insertAdjacentElement('afterend', groupElement);
        const addedItem = [];
        for (const item of target) {
            if (addedItem.includes(item))
                continue;
            let isGroupAdded = false;
            for (const svgGroup of svgGroups) {
                if (svgGroup.querySelector(`#${item.id}`)) {
                    groupElement.appendChild(svgGroup);
                    addedItem.push(...target.filter((element) => svgGroup.querySelector(`#${element.id}`)));
                    isGroupAdded = true;
                    break;
                }
            }
            if (!isGroupAdded) {
                groupElement.appendChild(item);
                addedItem.push(item);
            }
        }
    });
    if (groupAnimations.length > 0) {
        svgElement
            .querySelectorAll('.main > .element.group')
            .forEach((group) => group.remove());
    }
    return svgElement;
}
exports.prepareGroupAnimations = prepareGroupAnimations;
//# sourceMappingURL=gsap-utils.js.map